
import React, {Component} from 'react'
import CdnImage from '../../../components/cdnImage/cdnImage.js'

const configurationManager = require('../../../utils/config/configurationManager.js');
const themeUtil = require('../../../utils/view/themeUtil.js');
const navigationSecurityHandler = require('../navigationSecurityHandler.js');
class GenericDockButton extends Component 
{
    render()
    {
        let cloudName = configurationManager.getConfig().cdnAppCloudName;
        let size = Math.round(window.innerWidth*0.023);

        let isEnabled = navigationSecurityHandler.canAccess(this.props.button);
        let grayScale = !isEnabled;
        let opacity = isEnabled ? 1 : 0.6;
        let className = isEnabled ? "primary-color" : "disabled-color";
        let borderColor = isEnabled ? "var(--colors-primary)" : "#C0C0C0";
        let onClick = isEnabled ? ()=>{this.props.onClick(this.props.button)} : null;

        return <div onClick={onClick} style={{marginLeft:this.props.marginLeft, marginRight:this.props.marginRight}}>
                    <div style={{width:window.innerWidth*0.10, height: window.innerWidth*0.06, border:`1px solid ${borderColor}`, borderRadius:'10px'}}>
                        <div style={{position:'relative', top:'50%', left:'50%', transform:'translate(-50%, -50%)', textAlign:'center'}}>
                            <div style={{opacity:opacity}}>
                                <CdnImage grayScale={grayScale} cloudName={cloudName} width={size} publicId={themeUtil.getPublicId(`${this.props.button}.png`)}/>
                            </div>
                            <div className={className} style={{opacity:opacity, marginTop:'5px', paddingLeft:'10px', paddingRight:'10px'}}>
                                {this.props.caption}
                            </div>
                            
                        </div>
                    </div>
                </div>
    }
}

export default GenericDockButton